import { render } from "./recentCard.vue?vue&type=template&id=1eb3a00e"
import script from "./recentCard.vue?vue&type=script&lang=js"
export * from "./recentCard.vue?vue&type=script&lang=js"

import "./recentCard.vue?vue&type=style&index=0&id=1eb3a00e&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__